import { isNewRelicEnabled } from './newRelicConfig';

export type NewRelicLoginContext = {
  userId?: string;
  role?: string;
};

/** Syncs logged-in user context to NR when the browser agent is fully enabled. */
export function applyNewRelicUserContext(loginResponse: NewRelicLoginContext | undefined): void {
  if (!isNewRelicEnabled()) return;

  const nr = window.newrelic;
  if (!nr) return;

  if (loginResponse?.userId) {
    nr.setUserId?.(loginResponse.userId);
  }
  if (loginResponse?.role) {
    nr.setCustomAttribute?.('user.role', loginResponse.role, true);
  }
}
